import { useEffect, useState } from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import { getLicenceList, getLicenseId, getLicenseIdGlobal, getLicenseListglobal } from '../request/request'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import SelectTenantU from './SelectTenant_subs'
import { getsuscriptions, getsuscriptionsglobal } from '../request/request'
import styles from './ModalLicense.module.scss'
const API_URL = process.env.REACT_APP_API_URL


type Licence =
  {
    enddate: string,
    id: string,
    serial: string,
    startdate: string,
    total: number,
    description: string,
    type: string
  }
type x =
  {
    id: string
    name: string
    description: string
  }

interface VisiblePasswords {
  [index: number]: boolean;
}

type sus = {
  id: number
  purchaseOrden: string
  tenantId: number
}


const LicUpdateCreate = (props: any) => {
  /*********************************Constantes**************************************** */
  const tenant = useAppSelector(state => state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)
  const Type = useAppSelector(state => state.CloudSlice.Type)

  const { currentUser } = useAuth()
  const [selectedItems, setSelectedItems] = useState<number[]>([]);
  const [tenatselect, setTenantSelect] = useState('')

  const [InfoLicense, setInfoLicenece] = useState<Licence>({
    enddate: "",
    id: '',
    serial: "",
    startdate: '',
    total: 0,
    description: "",
    type: ''
  })


  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)

  //////////////////Const que se usan////////////////////////////////
  const [Devicescount, setcount] = useState(1)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [suscripcion, setsuscripcion] = useState<sus[]>([])
  const [Descriptionlic, setDescription] = useState('')

  /*************************SELECTOR DE SUBSCRIPTION**************************** */


  useEffect(() => {

    if (tenant === 0) {
      getsuscriptions().then(response => {
        setsuscripcion(response.data)
      })
    }
    else if (tenant !== 0) {
      getsuscriptionsglobal(tenatselect).then(response => {
        setsuscripcion(response.data)
      })
    }

  }, [tenatselect])

  const [susSelect, setsusselect] = useState<any>()

  const cambiarstate = (e: any) => {
    setsusselect(e.target.value)
  }

  const [Typelicense, settype] = useState<any>()

  const selecttype = (e: any) => {
    settype(e.target.value)
  }

  /************************************llamadas a la API ********************************************** */

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (props.id !== "" && props.id !== null) {
          if (currentUser?.ListPermiso?.includes('CTXR.License')) {
            if (tenant === 0 && Type !== 'Global') {
              const UserResponse = await getLicenseId(Id, props.id);
              setInfoLicenece(UserResponse.data);
              const permisosupdate = []
              for (const a of UserResponse.data.Permissions) {
                permisosupdate.push(a.id)
              }
              setSelectedItems(permisosupdate)
            }
            else if (tenant !== 0 && Type !== 'Global') {
              const UserResponse = await getLicenseIdGlobal(Id, props.id, tenant);
              setInfoLicenece(UserResponse.data);
              const permisosupdate = []
              for (const a of UserResponse.data.Permissions) {
                permisosupdate.push(a.id)
              }
              setSelectedItems(permisosupdate)
            }
            if (tenant === 0 && Type === 'Global') {
              const UserResponse = await getLicenseId(-1, props.id);
              setInfoLicenece(UserResponse.data);
              const permisosupdate = []
              for (const a of UserResponse.data.Permissions) {
                permisosupdate.push(a.id)
              }
              setSelectedItems(permisosupdate)
            }
            else if (tenant !== 0 && Type === 'Global') {
              const UserResponse = await getLicenseIdGlobal(-1, props.id, tenant);
              setInfoLicenece(UserResponse.data);
              const permisosupdate = []
              for (const a of UserResponse.data.Permissions) {
                permisosupdate.push(a.id)
              }
              setSelectedItems(permisosupdate)
            }
          }
        }
      } catch (error) {
        console.error('Error al obtener los permisos', error);
      }
    };

    fetchData();
  }, [props.id])








  /************************************************************************* */


  //const navigate = useNavigate();

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    try {

      if (tenatselect === '') {
        Swal.fire(
          'Ooops!',
          'Please select a Tenant',
          'warning')
      }
      else if (susSelect === '' || susSelect === undefined) {
        Swal.fire(
          'Ooops!',
          'Please select a Subscription',
          'warning')
      }
      else if (Descriptionlic === '') {
        Swal.fire(
          'Ooops!',
          'Please enter a description',
          'warning')
      }
      else if (Typelicense === '') {
        Swal.fire(
          'Ooops!',
          'Please select License Type',
          'warning')
      }
      else if (startDate === '') {
        Swal.fire(
          'Ooops!',
          'Please select Start Date',
          'warning')
      }
      else if (endDate === '') {
        Swal.fire(
          'Ooops!',
          'Please select End Date',
          'warning')
      }
      else if (Devicescount === 0) {
        Swal.fire(
          'Ooops!',
          'Please enter a valid device number.',
          'warning')
      }
      else {
        const permision = []
        for (const y of selectedItems) {
          permision.push({ id: y })
        }



        if (props.id === null) {
          const body = {
            tenantId: Number(tenatselect),
            subscriptionId: susSelect,
            startdate: startDate,
            enddate: endDate,
            total: Devicescount,
            description: Descriptionlic,
            type: Typelicense

          }
          if (tenant === 0) {
            await axios.post(API_URL + '/v1/CTX-R/add', body)
              .then(res => {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Your License has been created',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Ok',
                })
                props.setID(undefined);
                // Establecemos el ID de la nueva licencia para resaltarla
                props.setHighlightedId(res.data.subid);

                // Lógica global para recargar la lista completa de licencias
                if (Id !== 0 && Type !== 'Global') {
                  getLicenceList(Id).then(response => {
                    props.setRecords(response.data)
                  })
                } else if (Id === 0 && Type === 'Global') {
                  getLicenceList(-1).then(response => {
                    props.setRecords(response.data)
                  })
                }
              })
              .catch(error => {
                console.error('Error creating license:', error);
                Swal.fire('Error', 'There was an error creating the license.', 'error');
              });
          }
          else {
            await axios.post(API_URL + '/v1/CTX-R/add?tenantId=' + tenant, body)
              .then(res => {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Your License has been created',
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Ok',
                })
                props.setID(undefined);
                // Establecemos el ID de la nueva licencia para resaltarla
                props.setHighlightedId(res.data.subid);

                // Lógica global para recargar la lista completa de licencias
                if (Id !== 0 && Type !== 'Global') {
                  if (tenant === 0) {
                    getLicenceList(Id).then(response => {
                      props.setRecords(response.data)
                    })
                  } else {
                    getLicenseListglobal(Id, tenant).then(response => {
                      props.setRecords(response.data)
                    })
                  }
                } else if (Id === 0 && Type === 'Global') {
                  if (tenant === 0) {
                    getLicenceList(-1).then(response => {
                      props.setRecords(response.data)
                    })
                  } else {
                    getLicenseListglobal(-1, tenant).then(response => {
                      props.setRecords(response.data)
                    })
                  }
                }
              })
              .catch(error => {
                console.error('Error creating license:', error);
                Swal.fire('Error', 'There was an error creating the license.', 'error');
              });
          }
          //navigate('/support/SeeRequest')
        }
      }
    }
    catch (error: any) {
      console.log(error)

    }


  }


  const handleEdits = async (e: any) => {
    e.preventDefault();

    try {



      if (InfoLicense.description === '') {
        Swal.fire(
          'Ooops!',
          'Please enter a description',
          'warning')
      }
      else if (InfoLicense.type === '') {
        Swal.fire(
          'Ooops!',
          'Please select License Type',
          'warning')
      }
      else if (InfoLicense.startdate === '') {
        Swal.fire(
          'Ooops!',
          'Please select Start Date',
          'warning')
      }
      else if (InfoLicense.enddate === '') {
        Swal.fire(
          'Ooops!',
          'Please select End Date',
          'warning')
      }
      else if (InfoLicense.total === 0) {
        Swal.fire(
          'Ooops!',
          'Please enter a valid device number.',
          'warning')
      }
      else {
        const permision = []
        for (const y of selectedItems) {
          permision.push({ id: y })
        }

        if (props.id !== null) {
          const actualizar = {
            startdate: InfoLicense.startdate,
            enddate: InfoLicense.enddate,
            total: InfoLicense.total,
            description: InfoLicense.description,
            type: InfoLicense.type
          }

          if (tenant === 0 && Type !== 'Global') {
            await axios.put(API_URL + '/v1/CTX-R/' + Id + '/' + props.id, actualizar)
              .then(res => {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Your License has been updated',
                  showConfirmButton: false,
                  timer: 1500
                })
                props.setID(undefined);

                // "Reset" del highlightedId antes de setear el nuevo para forzar el rerender
                props.setHighlightedId(null);
                setTimeout(() => {
                  props.setHighlightedId(res.data.serial);
                }, 0);

                axios.get(API_URL + '/v1/CTX-R/' + Id + '/list')
                  .then(res => {
                    props.setRecords(res.data)
                  })
              });
          } else if (tenant === 0 && Type === 'Global') {
            await axios.put(API_URL + '/v1/CTX-R/' + -1 + '/' + props.id, actualizar)
              .then(res => {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Your License has been updated',
                  showConfirmButton: false,
                  timer: 1500
                })
                props.setID(undefined);

                props.setHighlightedId(null);
                setTimeout(() => {
                  props.setHighlightedId(res.data.serial);
                }, 0);

                axios.get(API_URL + '/v1/CTX-R/' + -1 + '/list')
                  .then(res => {
                    props.setRecords(res.data)
                  })
              });
          } else if (tenant !== 0 && Type !== 'Global') {
            await axios.put(API_URL + '/v1/CTX-R/' + Id + '/' + props.id + '?tenantId=' + tenant, actualizar)
              .then(res => {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Your License has been updated',
                  showConfirmButton: false,
                  timer: 1500
                })
                props.setID(undefined);

                props.setHighlightedId(null);
                setTimeout(() => {
                  props.setHighlightedId(res.data.serial);
                }, 0);

                axios.get(API_URL + '/v1/CTX-R/' + Id + '/list?tenantId=' + tenant)
                  .then(res => {
                    props.setRecords(res.data)
                  })
              });
          } else if (tenant !== 0 && Type === 'Global') {
            await axios.put(API_URL + '/v1/CTX-R/' + -1 + '/' + props.id + '?tenantId=' + tenant, actualizar)
              .then(res => {
                Swal.fire({
                  position: 'center',
                  icon: 'success',
                  title: 'Your License has been updated',
                  showConfirmButton: false,
                  timer: 1500
                })
                props.setID(undefined);

                props.setHighlightedId(null);
                setTimeout(() => {
                  props.setHighlightedId(res.data.serial);
                }, 0);

                axios.get(API_URL + '/v1/CTX-R/' + -1 + '/list?tenantId=' + tenant)
                  .then(res => {
                    props.setRecords(res.data)
                  })
              });
          }
        }
      }
    }
    catch (error: any) {
      console.log(error)

    }


  }



  ///////////////////////////////////////////////




  const handleCheckboxChange = (event: any) => {
    const { value, checked } = event.target;

    if (checked) {
      setSelectedItems((prevSelectedItems: Array<number>) => [...prevSelectedItems, Number(value)]);
    } else {
      setSelectedItems((prevSelectedItems: Array<number>) =>
        prevSelectedItems.filter((item) => item !== Number(value))
      );
    }
  };


  //////////////////////////////////////////////////

  return (

    <>
      {props.id !== null &&
        <div>
          <div
            className='modal fade show d-block'
            id='kt_modal_add_user'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
          >
            {/* begin::Modal dialog */}
            <div className='modal-dialog modal-dialog-centered mw-650px'>
              {/* begin::Modal content */}
              <div className='modal-content'>
                <ViewModalHeader setID={props.setID} />
                {/* begin::Modal body */}
                <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                  <form className='form w-100' id='kt_login_signin_form' onSubmit={handleEdits} >
                    {/* begin::Heading */}
                    {/*<Card4
                                icon='/media/svg/files/NubeTD.svg'
                                title=' '
    description=''></Card4>*/}
                    <div className='text-center mb-5'>
                      <h1 className='text-dark fw-bolder mb-3 f-titulo fs-md'>Edit License</h1>
                      <br />


                    </div>
                    {/* begin::Heading */}

                    {/* begin::Login options */}



                    {/* Campos solicitud */}
                    <div className='row'>
                      <div className=' col f-parrafo'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0' htmlFor="name">Description</label>
                        <input type="text" name='name' value={InfoLicense.description} className='form-control form-control-solid border-primary border-active'
                          onChange={(e: any) => setInfoLicenece({ ...InfoLicense, description: e.target.value })}
                        />
                      </div>
                      <div className='col'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="numero">License Type</label>
                        <select
                          className={`form-select form-control-solid border-gray-300 f-parrafo ${styles['custom-select-padding']}`}
                          aria-label="Select Type"
                          onChange={(e: any) => setInfoLicenece({ ...InfoLicense, type: e.target.value })}
                          value={InfoLicense.type}
                        >
                          <option hidden defaultValue={0}>Select Type</option>
                          <option value={'CTXR-1Y-L'}>CTXR-1Y-L</option>
                          <option value={'CTXR-TC-AWS-S-3Y'}>CTXR-TC-AWS-S-3Y</option>
                          <option value={'CTXR-TC-AWS-M-3Y'}>CTXR-TC-AWS-M-3Y</option>
                          <option value={'CTXR-TC-AWS-L-3Y'}>CTXR-TC-AWS-L-3Y</option>
                          <option value={'CTXR-TC-AWS-S-2Y'}>CTXR-TC-AWS-S-2Y</option>
                          <option value={'CTXR-TC-AWS-M-2Y'}>CTXR-TC-AWS-M-2Y</option>
                          <option value={'CTXR-TC-AWS-L-2Y'}>CTXR-TC-AWS-L-2Y</option>
                          <option value={'CTXR-TC-AWS-S-1Y'}>CTXR-TC-AWS-S-1Y</option>
                          <option value={'CTXR-TC-AWS-M-1Y'}>CTXR-TC-AWS-M-1Y</option>
                          <option value={'CTXR-TC-AWS-L-1Y'}>CTXR-TC-AWS-L-1Y</option>
                        </select>
                      </div>
                    </div>
                    <div className='f-parrafo'>
                      <label className='form-label fw-bolder text-dark fs-6 mb-0' htmlFor="name">Number of Devices</label>
                      <input type="text" name='name' value={InfoLicense.total} className='form-control form-control-solid border-primary border-active'
                        onChange={(e: any) => setInfoLicenece({ ...InfoLicense, total: e.target.value })}
                      />
                    </div>
                    <div className='row'>
                      <div className='col f-parrafo'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0' htmlFor="startDate">Start Date</label>
                        <input type="date" name='startDate' value={InfoLicense.startdate ? InfoLicense.startdate.substring(0, 10) : ''} className='form-control form-control-solid border-primary border-active'
                          onChange={(e: any) => setInfoLicenece({ ...InfoLicense, startdate: e.target.value })}
                        />
                      </div>
                      <div className='col f-parrafo'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0' htmlFor="endDate">End Date</label>
                        <input type="date" name='endDate' value={InfoLicense.enddate ? InfoLicense.enddate.substring(0, 10) : ''} className='form-control form-control-solid border-primary border-active'
                          onChange={(e: any) => setInfoLicenece({ ...InfoLicense, enddate: e.target.value })}
                        />
                      </div>
                    </div>

                    <br />

                    {/* begin::Action */}
                    <div className='d-flex flex-center d-grid mb-10'>

                      <button
                        type='submit'
                        id='kt_sign_in_submit'
                        className='btn btn-primary'


                      >
                        {!loading && <span className='indicator-label'>Save</span>}
                        {loading && (
                          <span className='indicator-progress' style={{ display: 'block' }}>
                            Please wait...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                    {/* end::Action */}


                  </form>

                </div>
                {/* end::Modal body */}
              </div>
              {/* end::Modal content */}
            </div>
            {/* end::Modal dialog */}
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </div>
      }


      {props.id === null &&
        <div>
          <div
            className='modal fade show d-block'
            id='kt_modal_add_user'
            role='dialog'
            tabIndex={-1}
            aria-modal='true'
          >
            {/* begin::Modal dialog */}
            <div className='modal-dialog modal-dialog-centered mw-650px'>
              {/* begin::Modal content */}
              <div className='modal-content'>
                <ViewModalHeader setID={props.setID} />
                {/* begin::Modal body */}
                <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
                  <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                    {/* begin::Heading */}
                    <div className='text-center mb-5'>
                      <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>Add License</h1>
                    </div>
                    {/* begin::Heading */}


                    {/* Campos solicitud */}
                    <div className='row'>
                      <div className='col'>
                        <SelectTenantU setTenantSelect={setTenantSelect}></SelectTenantU>
                      </div>
                      <div className='col'>
                        <label className='form-label fs-6 fw-bolder text-marino required form-label f-parrafo'>
                          Subscription
                        </label>
                        <select
                          className={`form-select form-control-solid border-gray-300 f-parrafo ${styles['custom-select-padding']}`}
                          aria-label="Select a Subscription"
                          onChange={cambiarstate}
                          value={susSelect}
                        >
                          {suscripcion.length === 0 && <option disabled selected hidden>No data</option>}
                          <option hidden defaultValue={0}>Select a Subscription</option>
                          {suscripcion.map((ins: any, x: any) =>
                            <option key={x} value={ins.id}>{ins.purchaseOrden}</option>
                          )}
                        </select>
                      </div>
                    </div>
                    <br />
                    <div className='row'>
                      <div className='col'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="numero">Description</label>
                        <input type="text"
                          name='numero'
                          className='form-control form-control-solid border-gray-300 f-parrafo'
                          id='numero'
                          value={Descriptionlic}
                          onChange={(e: any) => setDescription(e.target.value)}
                        />
                      </div>
                      <div className='col'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="numero">License Type</label>
                        <select
                          className={`form-select form-control-solid border-gray-300 f-parrafo ${styles['custom-select-padding']}`}
                          aria-label="Select Type"
                          onChange={selecttype}
                          value={Typelicense}
                        >
                          <option hidden defaultValue={0}>Select Type</option>
                          <option value={'CTXR-1Y-L'}>CTXR-1Y-L</option>
                          <option value={'CTXR-TC-AWS-S-3Y'}>CTXR-TC-AWS-S-3Y</option>
                          <option value={'CTXR-TC-AWS-M-3Y'}>CTXR-TC-AWS-M-3Y</option>
                          <option value={'CTXR-TC-AWS-L-3Y'}>CTXR-TC-AWS-L-3Y</option>
                          <option value={'CTXR-TC-AWS-S-2Y'}>CTXR-TC-AWS-S-2Y</option>
                          <option value={'CTXR-TC-AWS-M-2Y'}>CTXR-TC-AWS-M-2Y</option>
                          <option value={'CTXR-TC-AWS-L-2Y'}>CTXR-TC-AWS-L-2Y</option>
                          <option value={'CTXR-TC-AWS-S-1Y'}>CTXR-TC-AWS-S-1Y</option>
                          <option value={'CTXR-TC-AWS-M-1Y'}>CTXR-TC-AWS-M-1Y</option>
                          <option value={'CTXR-TC-AWS-L-1Y'}>CTXR-TC-AWS-L-1Y</option>
                        </select>
                      </div>
                    </div>

                    <br />
                    <div className='row'>
                      <div className='col'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="descripcion">Start Date</label>
                        <input type="date"
                          name='name'
                          className='form-control form-control-solid border-gray-300 f-parrafo'
                          id='descripcion'
                          value={startDate}
                          onChange={(e: any) => setStartDate(e.target.value)}
                        />
                      </div>
                      <div className='col'>
                        <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="descripcion">End Date</label>
                        <input type="date"
                          name='name'
                          className='form-control form-control-solid border-gray-300 f-parrafo'
                          id='descripcion'
                          value={endDate}
                          onChange={(e: any) => setEndDate(e.target.value)}
                        />
                      </div>
                    </div>
                    <br />
                    <div>
                      <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="numero">Number of Devices</label>
                      <input type="number"
                        name='numero'
                        className='form-control form-control-solid border-gray-300 f-parrafo'
                        id='numero'
                        value={Devicescount}
                        onChange={(e: any) => setcount(e.target.value)}
                      />
                    </div>
                    <br />
                    <br />

                    {/* end::Label */}
                    {/* end::Radio */}

                    {/* begin::Action */}
                    <div className='d-grid mb-10 justify-content-center'>

                      <button
                        type='submit'
                        id='kt_sign_in_submit'
                        className='btn btn-primary'
                        disabled={!currentUser?.ListPermiso?.includes('CTXR.License')}
                      >
                        {!loading && <span className='indicator-label'>Create License</span>}
                        {loading && (
                          <span className='indicator-progress' style={{ display: 'block' }}>
                            Please wait...
                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                          </span>
                        )}
                      </button>
                    </div>
                    {/* end::Action */}

                  </form>
                </div>
                {/* end::Modal body */}
              </div>
              {/* end::Modal content */}
            </div>
            {/* end::Modal dialog */}
          </div>
          {/* begin::Modal Backdrop */}
          <div className='modal-backdrop fade show'></div>
          {/* end::Modal Backdrop */}
        </div>
      }

    </>
  )
}
export { LicUpdateCreate }